<template>
    <div>
       <highcharts :options="chartOptions"></highcharts>
    </div>
</template>
<script>

import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting';
import More from 'highcharts/highcharts-more';
import GradeCalculationTypeEnum  from "../../GradeCalculationTypeEnum.js";
import MeasuredElementEnum  from "../../MeasuredElementEnum.js";

More(Highcharts)
Exporting(Highcharts)

export default {
  name:"GradeBoxPlot",  
  components: {
    highcharts: Chart
  },
  props: {
    height: {
      type: Number,
      default : 400
    },
    gradeCalculationType: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default : ''
    }
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: this.$props.title
        },
        chart: {
          type: 'boxplot',
          height: this.$props.height
        },
        series: [
          {
            name: this.$t('GradeControl.Grade'),
            data: [],
            point:{
              events: {
                click: (e) => {
                  this.pointClick(e)
                }
              }
            },
            tooltip: {
              headerFormat: "<em>" + this.$t('GradeControl.Location.Name') + " : {point.key}</em><br/>"
            }
          }
        ],
        xAxis: {
          categories: [],
          title: {
            text: this.$t('GradeControl.Location.Name')
          }
        },
        yAxis: {
          title: {
            text: this.$systemUnits.getGradeLabel('GradeControl.Grade')
          }
        }
      }
    };
  },
  
  methods: {
    pointClick(e) {
      this.$emit("onLocationSelected", e.point.category);
    },
    affectAttributes(stats) {
      if (stats) {
        const locations = [];
        const datas = [];
        

        stats.forEach(stat => {

          const gradeStats = this.getGradeStats(stat, this.$props.gradeCalculationType);
          const data = [
            this.$systemUnits.convertGrade(gradeStats.minGrade),
            this.$systemUnits.convertGrade(gradeStats.lowerQuantile),
            this.$systemUnits.convertGrade(gradeStats.medianGrade),
            this.$systemUnits.convertGrade(gradeStats.upperQuantile),
            this.$systemUnits.convertGrade(gradeStats.maxGrade)
          ];

          datas.push(data);
          locations.push(stat.locationCode);

        });

        this.chartOptions.series[0].data = datas;
        this.chartOptions.xAxis.categories = locations;
      }
    },
    getGradeStats(stat, gradeCalculation) {
      switch (gradeCalculation) {
      case GradeCalculationTypeEnum.SampleOnly:
        return stat.elementsGradeStats[MeasuredElementEnum.Gold];
      case GradeCalculationTypeEnum.SampleOrForecast:
        return stat.elementsGradeStats[MeasuredElementEnum.Gold];
      case GradeCalculationTypeEnum.SampleOnlyCapped:
        return stat.cappedElementsGradeStats[MeasuredElementEnum.Gold];
      case GradeCalculationTypeEnum.SampleOrForecastCapped:
        return stat.cappedElementsGradeStats[MeasuredElementEnum.Gold];
      }
    }
  }
};
</script>
